import React, { useCallback, useMemo } from "react";
import IfPermitted from "components/common/IfPermitted";
import { LinkContainer } from "components/common";
import { Button } from "components/bootstrap";
import usePluginEntities from "hooks/usePluginEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const useEntityCreator = (entityKey) => {
  const entityCreators = usePluginEntities("entityCreators");
  const entityCreator = useMemo(
    () => entityCreators.find((creator) => creator.id === entityKey),
    [entityCreators, entityKey]
  );
  if (!entityCreator) {
    throw new Error(`Entity creator "${entityKey}" not found!`);
  }
  return entityCreator;
};
const PermissionWrapper = ({
  permissions = void 0,
  children = void 0
}) => permissions ? /* @__PURE__ */ React.createElement(IfPermitted, { permissions }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
const CreateButton = ({ disabled = false, entityKey }) => {
  var _a;
  const entityCreator = useEntityCreator(entityKey);
  const sendTelemetry = useSendTelemetry((_a = entityCreator.telemetryEvent) == null ? void 0 : _a.section);
  const _onClick = useCallback(() => {
    const { telemetryEvent } = entityCreator;
    if (telemetryEvent) {
      sendTelemetry(telemetryEvent.type, {
        app_action_value: telemetryEvent.actionValue
      });
    }
  }, [entityCreator, sendTelemetry]);
  return /* @__PURE__ */ React.createElement(PermissionWrapper, { permissions: entityCreator == null ? void 0 : entityCreator.permissions }, /* @__PURE__ */ React.createElement(LinkContainer, { to: entityCreator.path }, /* @__PURE__ */ React.createElement(Button, { bsSize: "md", bsStyle: "primary", onClick: _onClick, disabled }, entityCreator.title)));
};
export default CreateButton;
